var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4376 28.6425C22.1635 28.4176 21.8063 28.2955 21.4377 28.3009C21.069 28.3062 20.7162 28.4385 20.4501 28.6712C20.1839 28.9039 20.024 29.2199 20.0025 29.5556C19.981 29.8914 20.0994 30.2222 20.3341 30.4816L23.5771 33.5868C23.7128 33.7168 23.876 33.8204 24.0567 33.8913C24.2375 33.9623 24.4321 33.9993 24.6288 34C24.8246 34.001 25.0185 33.9662 25.1992 33.8975C25.3799 33.8288 25.5436 33.7277 25.6806 33.6002L35.5849 24.2712C35.7191 24.1452 35.8249 23.9963 35.8961 23.833C35.9673 23.6697 36.0026 23.4952 35.9999 23.3194C35.9971 23.1437 35.9565 22.9702 35.8803 22.8088C35.8041 22.6474 35.6938 22.5013 35.5556 22.3787C35.4175 22.2562 35.2543 22.1597 35.0753 22.0948C34.8963 22.0298 34.705 21.9977 34.5124 22.0001C34.3198 22.0026 34.1296 22.0397 33.9527 22.1092C33.7758 22.1787 33.6156 22.2794 33.4813 22.4054L24.6434 30.7482L22.4376 28.6425Z",
    fill: "#27AE60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.54c3a215b4c9734dc7fffec1c4f2fc32.svg";
export { ForwardRef as ReactComponent };